function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { useMemo } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { useClassPrepend } from "../../../index";
import "./inlineLoader.css";
const InlineLoader = ({
  classPrepend = "styled",
  className = "",
  colorType = "inherit",
  showLoader = true
}) => {
  const [getClassName, getClassNameWithGlobal, getClassNameValue] = useClassPrepend(classPrepend);
  const colorTypeClassName = useMemo(() => {
    const colorTypeMap = {
      inherit: "inline-loader-indicator-inherit",
      primary: "inline-loader-indicator-primary"
    };
    const newColorTypeClassName = colorTypeMap?.[colorType];
    if (!newColorTypeClassName) return "";
    return newColorTypeClassName;
  }, [colorType]);
  if (showLoader === false) return null;
  return /*#__PURE__*/React.createElement("span", getClassNameWithGlobal(`inline-loader-indicator-wrapper ${className}`), /*#__PURE__*/React.createElement(FontAwesomeIcon, _extends({
    icon: faSpinner
  }, getClassNameWithGlobal(`inline-loader-indicator ${colorTypeClassName}`))));
};
export { InlineLoader };